import React, { FC, useRef, useState } from 'react'

import { Icon, IconColor, IconName } from 'Components/Icon'

type Props = {
  onChangeText?: (text: string) => void
  labelText?: string
  value?: string
}

export const SearchBar: FC<Props> = ({ onChangeText, labelText = 'Jetzt suchen …', value: valueFromProps }) => {
  const isControlled = valueFromProps !== undefined

  const [uncontrolledValue, setUncontrolledValue] = useState('')

  const value = isControlled ? valueFromProps : uncontrolledValue

  const inputRef = useRef<HTMLInputElement>(null)

  function handleValueChange(newValue: string): void {
    onChangeText?.(newValue)

    if (!isControlled) {
      setUncontrolledValue(newValue)
    }
  }

  function handleClear(): void {
    handleValueChange('')
    inputRef.current?.focus()
  }

  return (
    <div role="search" className="search-bar">
      <span className="search-bar-icon" aria-hidden="true">
        <Icon name={IconName.search} color={IconColor.GRAY_2} />
      </span>

      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(e) => handleValueChange(e.target.value)}
        autoFocus
        placeholder={labelText}
        aria-label={labelText}
      />

      {value && (
        <button type="button" onClick={handleClear} aria-label="Suchfeld leeren">
          <Icon name={IconName.close} color={IconColor.WHITE} aria-hidden />
        </button>
      )}
    </div>
  )
}
